//import { createRoot } from 'react-dom/client';
import React from 'react';
import Tether from 'tether'
import DatagridColumnApi from '../components/datagrid/DatagridColumnApi.js'
//import { ProjectQuickFilter } from '../components/datagrid/ProjectQuickFilter.jsx';
import {
  project_call_phase_set_window_form_path
} from '~/routes';

export const ProjectCallPhase = {
  initFormEditorApi: function() {
    import("../components/form_editor/form_editor_api.jsx").then(mod => {
      this.FormEditorApi = mod.default;
    });
  },
  FormEditorApi: null,

	list_forms: function() {
		var tableData = jQuery('#phase-form-table').data('table-content');
    var windowCols = jQuery('[data-col-type="window"]').map(function() {return jQuery(this).data('col-index');}).get();
    var oddWindowCols = windowCols.filter(function(v){ return v%2!=0 });
    var evenWindowCols = windowCols.filter(function(v){ return v%2==0 });

    jQuery('#phase-form-table').delegate('input[type="radio"][name^="window"]', 'change', function() {
      var val = jQuery('input[type="radio"][name="'+jQuery(this).attr('name')+'"]:checked').val();
      jQuery.ajax({
        url: project_call_phase_set_window_form_path({format: null}),
        method: 'post',
        data: {form_id: val, window_id: jQuery(this).data('window')}
      });
    });   

    var windowCellRender = function(data, type, row, meta) {
      if (type == 'display') {
        var $r = jQuery('<input>').attr('type', 'radio').
          attr('name', data.name).
          attr('value', data.value).
          attr('data-window', data.window);
        if (data.checked) {
          $r.attr('checked', 'checked');
        }
        return jQuery('<div>').append($r).html();
      }
      return '';
    };

		ActionJS.ProjectCallPhase.priv.phaseFormTable = jQuery('#phase-form-table').DataTable({
      data: tableData,
      pageLength: -1,
      autoWidth: false,
      lengthChange: false,
      filter: false,
      columnDefs: [
        {
          render: windowCellRender,
          className: 'window-odd',
          sorting: false,
          targets: oddWindowCols
        },
        {
          render: windowCellRender,
          sorting: false,
          className: 'window-even',
          targets: evenWindowCols
        },
      	// {
      	// 	render: function(data, type, row, meta) {
				// 		if (type == 'display') {
	      //       var link = jQuery('<a>').attr('href', data.url).text(data.title).addClass(data.class).attr('data-drafts', data.drafts).attr('data-submitted', data.submitted);
	      //       return jQuery('<div>').append(link).html();
	      //     }
	      //     return data.title;
	      // 	},
      	// 	targets: [(tableData[0] ? tableData[0].length - 1 : null)]
        // },
        {
      		render: function(data, type, row, meta) {
            var selected = "";
            if (data.annexes) {
              selected = data.annexes.sort(function(a,b) {return (a.sort_order > b.sort_order) ? 1 : ((b.sort_order > a.sort_order) ? -1 : 0);}).map(function(d){
                if (type == 'display') {
                  return '<div class="annex"><span>' + d.annex_name + '</span>' + '<span class="text-truncate">' + d.form_title + '</span></div>';
                }else{
                  return d.annex_name + ' - ' + d.form_title;
                }
              }).reduce( function(prev, curr) {return prev + curr; });
            }
              return selected;
          },
          width: '200px',
      		targets: 'annex-column'
      	}
      ],
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    });

    jQuery('.edit-form-link').on('click', function (event){
      var drafts = jQuery(this).attr('data-drafts');
      var submitted = jQuery(this).attr('data-submitted');

      if (drafts > 0 || submitted > 0) {
        if (!confirm(I18n.t('there_are_applications', { drafts: drafts, submitted: submitted}))) {
          event.preventDefault();
        }
      }
    });

    jQuery('.delete-form-link').on('click', function(e){
      e.preventDefault();
      var confirmed = confirm(jQuery(this).data('confirm-text'));
      if (confirmed){
        jQuery.post(jQuery(this).attr('href'), function(d){
          location.reload();
        });
      }
    })
	},


  edit_form: function() {
    this.initFormEditorApi();
    const self = this;

    jQuery('#phase-content-form').on('submit', function() {
      jQuery(this).append('<input type="hidden" name="form" />');
      jQuery(this).find('input[name="form"]').val(JSON.stringify(self.FormEditorApi.getFormJSON()));
    });

    jQuery('.form-preview').on('click', ActionJS.ProjectCallPhase.preview_form);

    jQuery('.form-preview-pdf').on('click', ActionJS.ProjectCallPhase.preview_form_pdf);
  },

  preview_form: function() {
    var modalBody = jQuery('#modal-dialog .modal-body');
    var projectId = jQuery('#project-context-selector').get(0).getAttribute('data-project-id');

    const renderForm = () => {
      let previewContainer = modalBody.find('#report-container').get(0);
      this.FormEditorApi.unmountForm();
      previewContainer.setAttribute('data-project-id', projectId);
      let form = this.FormEditorApi.getFormJSON();

      var viewMode = this.FormEditorApi.getViewMode();
      this.FormEditorApi.renderForm(previewContainer, {
        form: form,
        //formId: this.FormEditorApi.getFormId(),
        language: this.FormEditorApi.getCurrentLanguage(),
        availableLanguages: this.FormEditorApi.getAvailableLanguages(),
        toggleViewMode: true,
        viewMode: viewMode,
        editable: viewMode == 'form',
        programmeFormId: this.FormEditorApi.getFormId(),
        optionSetValues: this.FormEditorApi.getOptionSetValues(),
        optionSetHierarchyValues: this.FormEditorApi.getOptionSetHierarchyValues()
      })
    }

    this.initFormEditorApi();
    setTimeout(() => {
      modalBody.html('<div id="project-selector"></div><div id="report-container" class="form-preview-modal"></div>');

      // Somewhat hacky solution to fake the project context in preview
      // if (this.FormEditorApi.getRequiresContext()) {
      //   const root = createRoot(modalBody.find('#project-selector').get(0));
      //   root.render(
      //       React.createElement(ProjectQuickFilter, {
      //         onChangeProjectContext: renderForm,
      //         noFilterProps: {disabled : true, text: I18n.t('project').toUpperCase()}
      //       }));
      // } else {
        renderForm();
      // }
    }, 500);
  },


  preview_form_pdf: function() {
    ProjectCallPhase.initFormEditorApi();
    const self = ProjectCallPhase;
    var form = jQuery('#phase-content-form');
    var link = jQuery(this);
    form.append('<input type="hidden" name="form" />');
    form.find('input[name="form"]').val(JSON.stringify(self.FormEditorApi.getFormJSON()));
    const href = link.attr('href').replace(/(\?|&)language=\.+$/, '') + (link.attr('href').match(/\?/) ? '&' : '?') + 'language=' + self.FormEditorApi.getCurrentLanguage()
    jQuery.post(href, form.serialize());
    return false;
  },


  update_form: function() {
    this.edit_form();
  },


  form_editor_ready: function() {
    // Init selection of report keys from other forms.
    // This is done outside the form editor since the implementation
    // is quite SmartME specific.
    var hideKeyDropdown = function() {
      jQuery('.form-editor-report-key-dropdown').remove();
    };
    jQuery('.form-editor').
      on('focus', 'input[name="reportKey"]', function(event) {
        hideKeyDropdown();

        var input = jQuery(this);
        var dropContent = jQuery("#form-editor-report-key-dropdown-template").html().replace("__component_type__", input.data("component-type") || "");
        var dropdown = jQuery(dropContent).appendTo('body');
        
        var tether = new Tether({
          element: dropdown,
          target: input,
          attachment: 'top left',
          targetAttachment: 'bottom left',
          constraints: [{
            to: 'scrollParent',
            attachment: 'together',
            pin: true
          }]
        });
        dropdown.outerWidth(input.outerWidth()).show();
        window.initModalDialogs();
      }).
      on('keydown', 'input[name="reportKey"]', hideKeyDropdown).
      on('mousedown', function(event) {
        if (!jQuery(event.currentTarget).is('.form-editor-report-key-dropdown *')) {
          hideKeyDropdown();
        }
      });
  },


  form_editor_changed: function() {
    jQuery('.form-editor').closest('form').attr('data-state-changed', true);
  },


  edit_annexes: function() {
    jQuery('#annex-form').sortable({
      items: '.annex-row',
      handle: '.annex-reorder',
      axis: 'y',
      start: function (e, ui) { $(ui.item).addClass('phase-dragging') },
			stop: function (e, ui) { $(ui.item).removeClass('phase-dragging') },
			update: function () {
				ActionJS.ProjectCallPhase.priv.saveAnnexOrder();
			}
    })

    jQuery('#new-annex').on('click', function(e){
      e.preventDefault();
      var id = SmartME.generateUniqueId();
      jQuery('#annex-form').append(jQuery('#annex-row-template').html().replace(/__id__/g, id).replace(/__sort_order__/, jQuery('#annex-form > .annex-row').length + 1));
    });
    
    jQuery('#annex-form').on('click', '.delete-annex', function(e){
      e.preventDefault();
      if (jQuery(this).closest('.row').find('#form_id').val() != "") {
        //console.log("AA:" + jQuery(this).closest('.row').find('#form_id').val())
        if (confirm(I18n.t('deleting_annex_confirmation'))) {
          jQuery(this).closest('.row').remove();
        }
      } else {
        jQuery(this).closest('.row').remove();
      }
    });
    
  },


  form_editor_browse_keys: function() {
    jQuery('.modal-body .nav-tabs').on('click', 'li a', function() {
      var currentLi = jQuery(this).closest('li');
      var ul = currentLi.closest('ul');
      ul.find('> li').removeClass('active');
      currentLi.addClass('active');
      ul.parent().find('> .tab-content').hide();
      ul.parent().find('> .tab-content.tab-' + currentLi.attr('data-tab-id')).show();
      return false;
    });

    jQuery('.modal-body > .tab-content').on('click', 'a.select[data-key]', function() {
      jQuery('.form-editor input[name="reportKey"]').val(this.getAttribute('data-key')).trigger('change');
      jQuery('#modal-dialog').modal('hide');
      jQuery('.form-editor-report-key-dropdown').remove();
      return false;
    });

    $('#search-browse_keys').on('keyup paste', function() {
      var value = $(this).val().toUpperCase();
      var $rows = $('.browse_keys-container table tbody tr');

      if(value === '') {
        $rows.show(100);
        return false;
      }

      $rows.each(function(index) {
        var $row = $(this);

        var title = $row.find('td').html().toUpperCase();
        title.indexOf(value) > -1 ? $row.show(100) : $row.hide(100);
      });
    });

    $(document).ready(function() {
      $('.browse_keys-container').each(function() {
        if ($(this).find('tbody tr').length == 0) $(this).hide();
      });
    });
  },


  form_editor_open_option_library: function(componentId, dependencyId, language) {
    openModalDialog({
        title: I18n.t('form_option_library'),
        modalClass: 'modal-lg',
        hideButtons: true,
        url: jQuery('#form-editor-option-library-url').html().trim() + 
          '?component_id=' + componentId +
          '&dependency_id=' + dependencyId +
          '&language=' + language
    });
  },

  form_editor_option_library: function(componentId, dependencyId) {
    this.initFormEditorApi();
    const self = this;

    jQuery('.modal-body .nav-tabs').on('click', 'li a', function() {
      var currentLi = jQuery(this).closest('li');
      var ul = currentLi.closest('ul');
      ul.find('> li').removeClass('active');
      currentLi.addClass('active');
      ul.parent().find('> .tab-content').hide();
      ul.parent().find('> .tab-content.tab-' + currentLi.attr('data-tab-id')).show();
      return false;
    });
    jQuery('.modal-body .nav-tabs .libs .active a').trigger('click');

    jQuery('.modal-body > .tab-content').on('click', 'a.select[data-options]', function() {
      if (componentId == 'datagrid-selection-options'){
        DatagridColumnApi.addOptions(JSON.stringify(jQuery(this).data('options')))
      } else {
        self.FormEditorApi.addOptions(componentId, dependencyId, jQuery(this).data('options'));
      }
      jQuery('#modal-dialog').modal('hide');
      return false;
    });
  },

  form_editor_open_option_library_ag_grid_v: function(componentId, dependencyId, language) {
    openModalDialog({
      title: I18n.t('form_option_library'),
      modalClass: 'modal-xl',
      hideButtons: true,
      url: jQuery('#form-editor-option-library-ag-grid-v-url').html().trim() +
        '?component_id=' + componentId +
        '&dependency_id=' + dependencyId +
        '&language=' + language
    });
  },

  form_editor_open_option_set_library_ag_grid_v: function(componentId, dependencyId, language) {
    openModalDialog({
      title: I18n.t('form_option_library'),
      modalClass: 'modal-xl',
      hideButtons: true,
      url: jQuery('#form-editor-option-set-library-ag-grid-v-url').html().trim() +
        '?component_id=' + componentId +
        '&dependency_id=' + dependencyId +
        '&language=' + language
    });
  },

  form_editor_option_set_library_ag_grid_v: function(componentId, dependencyId) {
    this.initFormEditorApi();
    const self = this;
    jQuery('.modal-body .ag-form-option-library').on('click', 'a.select[data-option-set-key]', function() {
      var el = jQuery(this);
      self.FormEditorApi.setOptionSetKey(componentId, dependencyId, el.data('option-set-key'), el.attr('data-skip-duplicates'));
      jQuery('#modal-dialog').modal('hide');
      return false;
    });
  },

  form_editor_option_library_ag_grid_v: function(componentId, dependencyId) {
    this.initFormEditorApi();
    const self = this;
    jQuery('.modal-body .ag-form-option-library').on('click', 'a.select[data-options]', function() {
      var el = jQuery(this);
      if (componentId == 'datagrid-selection-options'){
        DatagridColumnApi.addOptions(JSON.stringify(el.data('options')), el.attr('data-skip-duplicates'))
      } else {
        self.FormEditorApi.addOptions(componentId, dependencyId, el.data('options'), el.attr('data-skip-duplicates'));
      }
      jQuery('#modal-dialog').modal('hide');
      return false;
    });
  },

  add_form_variable: function(componentId) {
    this.initFormEditorApi();

    jQuery('.modal-body .nav-tabs').on('click', 'li a', function() {
      var currentLi = jQuery(this).closest('li');
      var ul = currentLi.closest('ul');
      ul.find('> li').removeClass('active');
      currentLi.addClass('active');
      ul.parent().find('> .tab-content').hide();
      ul.parent().find('> .tab-content.tab-' + currentLi.attr('data-tab-id')).show();
      return false;
    });
    jQuery('.modal-body .nav-tabs .libs .active a').trigger('click');

    jQuery('.modal-body > .tab-content').on('click', 'a.select[data-key]', function() {
      this.FormEditorApi.addVariable(componentId, jQuery(this).data('form-id'), jQuery(this).data('form-entity'), jQuery(this).data('key'));
      jQuery('#modal-dialog').modal('hide');
      return false;
    });
  },


	priv: {
		phaseFormTable: null,
    saveAnnexOrder: function() {
      $('[name^="annexes["][name$="][sort_order]"]').each(function(i,e){$(this).val(i+1);});
    }
	}
}
